import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { StackScreen } from "@life-line-lab/components-react";
import { Helmet } from "react-helmet";
import useOrderSettingsEdit from "../order-processing/use-order-settings-edit";
import { getEnumOfOrderSettings } from "Helpers/order-settings-helper";

const OrderProcessingSettingsForm = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const {
    expandedWidth,
    type,
    id,
    activeComponent,
    setActiveComponent,
    orderSettingState,
    setOrderSettingState,
    permission,
    handleFetchOrderSettingsList,
    handleFetchOrderSettings,
  } = useOrderSettingsEdit();

  const handleCloseStackScreen = () => {
    history.push(`/order-management/settings?tabKey=${type}`);
  };

  return (
    <StackScreen
      title={
        <div>
          <img
            alt={t("alt.logo")}
            src="/assets/images/banner_logo.png"
            height={30}
          />
        </div>
      }
      isOpen={true}
      renderHeader={<div></div>}
      onClose={handleCloseStackScreen}
      className={
        expandedWidth.includes(getEnumOfOrderSettings(type)) ? "rate-table" : ""
      }
    >
      <Helmet>
        <title></title>
      </Helmet>
      {activeComponent}
    </StackScreen>
  );
};

export default OrderProcessingSettingsForm;
